import React from 'react';
import { ClipboardDocumentCheckIcon, PresentationChartLineIcon, AcademicCapIcon, DocumentTextIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import ServiceCard from '../components/ui/ServiceCard';

const Servicos: React.FC = () => {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Nossos Serviços</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluções completas para elevar a qualidade dos seus processos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <ServiceCard 
            title="Auditoria de Processos" 
            description={(
              <>
                Auditorias de processo com foco na conformidade, eficiência e melhoria contínua.<br />
                <br />
                Avaliamos a aderência aos requisitos normativos e aos procedimentos internos, identificando oportunidades de otimização e mitigação de riscos.
                
              </>
            )}
            icon={<ClipboardDocumentCheckIcon className="h-10 w-10" />}
          />
          <ServiceCard 
            title="Consultoria Técnica" 
            description={(
              <>
                Consultoria especializada na implementação, manutenção e melhoria de Sistemas de Gestão baseados nas normas internacionais ISO 9001 (Qualidade), ISO 14001 (Meio Ambiente), ISO 45001 (Saúde e Segurança Ocupacional) e ISO 27001 (Segurança da Informação).             
              </>
            )}
            icon={<PresentationChartLineIcon className="h-10 w-10" />}
          />
          <ServiceCard 
            title="Treinamentos" 
            description={(
              <>
                Cursos, workshops e palestras personalizados voltados à capacitação de equipes nos requisitos das normas ISO 9001, ISO 14001, ISO 45001 e ISO 27001.<br />
                <br />
                Nossos programas combinam teoria e prática, promovendo o entendimento dos sistemas de gestão e fortalecendo a cultura da qualidade, segurança, meio ambiente e proteção da informação dentro da organização.
              </>
            )}
            icon={<AcademicCapIcon className="h-10 w-10" />}
          />
          <ServiceCard 
            title="Gestão Documental"             
            description={(
              <>
                Apoiamos sua empresa na estruturação e controle eficaz de documentos e registros, garantindo organização,
                rastreabilidade e conformidade com os requisitos das normas ISO.<br />
              
              </>
            )}
            icon={<DocumentTextIcon className="h-10 w-10" />}
          />
          <ServiceCard 
            title="Desenvolvimento de Equipes" 
            description="Programas de capacitação e desenvolvimento para equipes de qualidade, com foco em habilidades técnicas e comportamentais."
            icon={<UserGroupIcon className="h-10 w-10" />}
          />
        </div>

        <div className="bg-gray-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">Metodologia de Trabalho</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded shadow">
              <div className="text-primary text-2xl font-bold mb-2">01</div>
              <h3 className="text-lg font-semibold mb-2">Diagnóstico</h3>
              <p className="text-gray-600">Análise detalhada da situação atual, identificando pontos fortes e oportunidades de melhoria.</p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <div className="text-primary text-2xl font-bold mb-2">02</div>
              <h3 className="text-lg font-semibold mb-2">Planejamento</h3>
              <p className="text-gray-600">Desenvolvimento de um plano de ação personalizado, com metas e prazos definidos.</p>
            </div>
            <div className="bg-white p-6 rounded shadow">
              <div className="text-primary text-2xl font-bold mb-2">03</div>
              <h3 className="text-lg font-semibold mb-2">Implementação</h3>
              <p className="text-gray-600">Execução das ações planejadas, com acompanhamento constante e ajustes quando necessário.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicos;